import { render, staticRenderFns } from "./ConfirmSurg.vue?vue&type=template&id=9845c9a8&scoped=true&"
import script from "./ConfirmSurg.vue?vue&type=script&lang=js&"
export * from "./ConfirmSurg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9845c9a8",
  null
  
)

export default component.exports